import { Chart } from 'chart.js';
import { DashboardDetailPage } from './../dashboard-detail/dashboard-detail';
import { FoserviceProvider } from './../../providers/foservice/foservice';
import { AuthProvider } from './../../providers/auth/auth';
import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the FoInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-fo-info',
  templateUrl: 'fo-info.html',
})
export class FoInfoPage {
  @ViewChild('pieChart') pieChart;
  period = [];
  trans_count = [];
  night_count = [];
  pax_count = [];
  public pieChartEl: any;
  public chartLoadingEl: any;

  dash: {};
  dash2: {};
  dash3: {};
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private foservice: FoserviceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {

    let info = this.auth.getUserInfo();
    this.name = info.name;
    this.username = info.username;
    this.serverlocation = info.serverlocation;
    this.userid = info.userid;
    this.token = info.token;
    this.loadData();
  }

  public loadData() {
    //this.showLoading()
    this.showLoading();

    this.foservice.loadDashboard(this.userid, this.token, this.serverlocation, this.global.ICNO)
    .then(data => {
      this.dash = data;
      console.log(this.dash);
      //this.loading.dismiss();
        this.foservice.loadDashboardDetail(this.userid, this.token, this.serverlocation, this.global.ICNO)
          .then(data => {
            this.dash2 = data;
            console.log(this.dash2);
            this.foservice.loadDashboardChart(this.userid, this.token, this.serverlocation, this.global.ICNO)
              .then(data => {
                this.dash3 = data;
                //Fill data here
                let k : any;

                //Reset Array
                this.trans_count = [];
                this.night_count =[];
                this.pax_count =[];
                this.period = [];

                //var datas = [];
                for(k in this.dash3)
                {
                  console.log(this.dash3[k]['Trans']);

                  this.period.push(this.dash3[k]['Period']);
                  this.trans_count.push(this.dash3[k]['Trans']);
                  this.night_count.push(this.dash3[k]['Night']);
                  this.pax_count.push(this.dash3[k]['Pax']);
                }
                this.createPieChart();
              });
            this.loading.dismiss();
          });
    });

  }

  createPieChart(){
    this.pieChartEl 			= new Chart(this.pieChart.nativeElement,
      {
         type: 'line',
         data: {
             labels: this.period,
             datasets: [{
                 label                 : 'Trans',
                 data                  : this.trans_count,
                 duration              : 2000,
                 easing                : 'easeInQuart',
                 backgroundColor       : "rgba(59, 89, 152, 0.75)",
                 hoverBackgroundColor  : "rgba(59, 89, 152, 1)",
             },
              {
                label                 : 'Night',
                 data                  : this.night_count,
                 duration              : 2000,
                 easing                : 'easeInQuart',
                 backgroundColor       : "rgba(29, 202, 255, 0.75)",
                 hoverBackgroundColor  : "rgba(59, 89, 152, 1)",
              },
              {
                label                 : 'Pax',
                 data                  : this.pax_count,
                 duration              : 2000,
                 easing                : 'easeInQuart',
                 backgroundColor       : "rgba(211, 72, 54, 0.75)",
                 hoverBackgroundColor  : "rgba(59, 89, 152, 1)",
              }
            ]
         },
         options : {
              maintainAspectRatio: false,
              legend         : {
                display     : true,
                boxWidth    : 80,
                fontSize    : 15,
                padding     : 0
              },
              title: {
                display: true,
                text: 'Total - Last Three Months'
              },
              scales: {
                  yAxes: [{
                      ticks: {
                        beginAtZero:true,
                        stepSize: 1000
                      }
                  }],
                  xAxes: [{
                      ticks: {
                        autoSkip: false
                      }
                  }]
              }
          }
      });
      //this.chartLoadingEl = this.pieChartEl.generateLegend();
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadData();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }
  itemTapped(event, detail) {
    this.navCtrl.push(DashboardDetailPage, {
      detail: detail
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FoInfoPage');
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.adjustScrollPadding();
      if (this.pieChartEl) {
        this.pieChartEl.resize();
      }
    }, 100);
  }

  private getVisibleNavbarHeight(): number {
    const navbars = Array.from(document.querySelectorAll('ion-navbar')) as HTMLElement[];
    for (const nb of navbars) {
      if (nb.offsetParent !== null && nb.offsetHeight > 0) {
        return nb.offsetHeight;
      }
    }
    return 56;
  }

  private adjustScrollPadding() {
    const height = this.getVisibleNavbarHeight();
    const scrollContent = document.querySelector('page-fo-info .scroll-content') as HTMLElement;
    if (scrollContent) scrollContent.style.paddingTop = height + 'px';
    const refresher = document.querySelector('page-fo-info ion-refresher') as HTMLElement;
    if (refresher) refresher.style.top = height + 'px';
  }

}



// WEBPACK FOOTER //
// ./src/pages/fo-info/fo-info.ts